<div class="search_container position-relative">
  <span class="material-symbols-outlined">search</span>
  <mat-form-field [floatLabel]="'never'">
    <input matInput placeholder="Search AutoPredict">
  </mat-form-field>
</div>